/* Read https://hello.atlassian.net/wiki/spaces/DQ/pages/786078865 on how to instrument well. */

// These are entities in ProForma. Reuse as much as possible.
// Think carefully when making a new ActionSubject about whether you can reuse an existing one.
export var ActionSubject = /*#__PURE__*/function (ActionSubject) {
  // Objects
  ActionSubject["FORM"] = "form";
  // An actual form on an issue.
  ActionSubject["FORM_FIELD"] = "formField";
  // A field in a form.
  ActionSubject["FORM_FIELD_CHOICES_DATA_CONNECTION"] = "formFieldChoicesDataConnection";
  // A data connection's choices in a form.
  ActionSubject["FORM_FIELD_CHOICES_JIRA_FIELD"] = "formFieldChoicesJiraField";
  // A Jira field's choices in a form.
  ActionSubject["FORM_SETTINGS_LANGUAGE"] = "formSettingsLanguage";
  // Language dropdown of a form in form settings.
  ActionSubject["FORM_SETTINGS_SUBMIT"] = "formSettingsSubmit";
  // Lock and PDF of a form on submit toggle in form settings.
  ActionSubject["FORM_SETTINGS_ISSUE_CREATE"] = "formSettingsIssueCreate";
  // Submit and validate on create toggle in form settings.
  ActionSubject["FORM_SETTINGS_ISSUE_FORMS_TYPES"] = "formSettingsIssueFormsTypes";
  // Issue forms types dropdown in form settings, enabled through issue forms toggle.
  ActionSubject["FORM_SETTINGS_RECOMMENDED_FORMS_TYPES"] = "formSettingsRecommendedFormsTypes";
  // Recommended forms types dropdown in form settings, enabled through recommended forms toggle.
  ActionSubject["FORM_SETTINGS_REQUEST_CREATE_TYPES"] = "formSettingsRequestCreateTypes";
  // Request create types dropdown in form settings, enabled through request create toggle ("Attach to request types").
  ActionSubject["QUESTION_ANSWER"] = "questionAnswer";
  // Answer of a Question in a form.
  ActionSubject["TEMPLATE_FORM"] = "templateForm";
  // A form in a project created by form builder than can be then instantiated on an issue.
  ActionSubject["EXAMPLE_TEMPLATE"] = "exampleTemplate";
  // Predefined templates available in the form builder that can be inserted into a template form.
  ActionSubject["BUTTON"] = "button";
  ActionSubject["DROPDOWN_ITEM"] = "dropdownItem";
  ActionSubject["SELECT_ITEM"] = "selectItem";
  ActionSubject["FILTER"] = "filter";
  ActionSubject["LIST"] = "list";
  ActionSubject["PANEL"] = "panel";
  ActionSubject["SECTION"] = "section";
  ActionSubject["TABLE"] = "table";
  ActionSubject["MODAL"] = "modal";
  ActionSubject["PROFORMA_API"] = "proformaAPI";
  ActionSubject["PROFORMA_UI"] = "proformaUI";
  ActionSubject["SECTION_MESSAGE"] = "sectionMessage";
  ActionSubject["ATTACHMENT"] = "proformaAttachment";
  ActionSubject["ATTACHMENT_UPLOAD"] = "proformaAttachmentUpload";
  ActionSubject["ATTACHMENT_VIEWER"] = "proformaAttachmentViewer";
  ActionSubject["ATTACHMENT_VIEWER_CARD"] = "proformaAttachmentViewerCard";
  ActionSubject["REQUEST_TYPE"] = "requestType";
  ActionSubject["DUPLICATE_REQUEST_TYPE_LINKED_FIELDS_WARNING_MODAL"] = "duplicateRequestTypeLinkedFieldsWarningModal";
  ActionSubject["TRANSLATIONS_EDITOR"] = "translationsEditor";
  ActionSubject["FORM_PERMISSIONS"] = "proformaFormPermissions";
  // Processes
  ActionSubject["ADF_NODE_INSERT"] = "adfNodeInsert";
  ActionSubject["FORM_VALIDATION"] = "formValidation";
  ActionSubject["FORM_EDIT"] = "formEdit";
  ActionSubject["FORM_SAVE"] = "formSave";
  ActionSubject["SEARCH_ASYNC_CHOICES"] = "searchAsyncChoices";
  ActionSubject["FETCH_FORM_ATTACHMENTS"] = "fetchFormAttachments";
  ActionSubject["UPLOAD_ISSUE_FORM_ATTACHMENTS"] = "uploadFormAttachments";
  ActionSubject["TRANSLATIONS_LANGUAGES_LOAD"] = "translationsLoad";
  ActionSubject["TRANSLATIONS_LOAD"] = "translationsLoad";
  ActionSubject["TRANSLATIONS_SAVE"] = "translationsSave";
  ActionSubject["TRANSLATIONS_DELETE"] = "translationsDelete";
  return ActionSubject;
}({});

// Actions that can be performed on ActionSubjects. Try to use common ones from the list.
// See https://hello.atlassian.net/wiki/spaces/DQ/pages/1021070478
export var Action = /*#__PURE__*/function (Action) {
  // Objects
  Action["ADDED"] = "added";
  // When an entity is added/inserted into another.
  Action["CLICKED"] = "clicked";
  Action["CREATED"] = "created";
  Action["DELETED"] = "deleted";
  Action["DOWNLOADED"] = "downloaded";
  Action["EXPORTED"] = "exported";
  Action["UPDATED"] = "updated";
  Action["VIEWED"] = "viewed";
  Action["SELECTED"] = "selected";
  Action["COPIED"] = "copied";
  // Processes
  Action["FAILED"] = "failed";
  Action["FINISHED"] = "finished";
  Action["STARTED"] = "started";
  Action["STOPPED"] = "stopped";
  return Action;
}({});

// Mechanisms to update a Form.
export var FormUpdateType = /*#__PURE__*/function (FormUpdateType) {
  FormUpdateType["REOPEN"] = "REOPEN";
  FormUpdateType["SAVE"] = "SAVE";
  FormUpdateType["SET_EXTERNAL"] = "SET_EXTERNAL";
  FormUpdateType["SET_INTERNAL"] = "SET_INTERNAL";
  FormUpdateType["SUBMIT"] = "SUBMIT";
  FormUpdateType["CLOSE"] = "CLOSE"; // Similar to SUBMIT, used in "Close customer edits" option in form card meatball menu
  return FormUpdateType;
}({});